module.exports = __webpack_public_path__ + "assets/img/jeffrey.4aa7fbe9.png";